import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { TRootState } from 'redux/store';
import { TUserStatus } from 'modules/auth/services/type';

type TGDPState = {
  onboardingState: {
    status: TUserStatus | null;
    isOnboardMeetingBooked: boolean | null;
    showOnboardingTutorial?: boolean | null;
    isLoading: boolean;
    onboardingStepProgress?: {
      info: boolean; // tell us questions
      isValidDentist: boolean;
      isEmailVerified: boolean;
      isOnboardingBooked: boolean;
      isOnboardingComplete: boolean;
    };
  };
};

const initialState: TGDPState = {
  /* We use this instead state.auth.user because
   * we store state.auth in localStorage and it can be outdated on
   * page open, so it is better to wait until user request finished
   * to use actual BE data for onboarding and user state */
  onboardingState: {
    isLoading: true,
    status: null,
    isOnboardMeetingBooked: null,
    showOnboardingTutorial: null,
    onboardingStepProgress: undefined,
  },
};

const slice = createSlice({
  name: 'gdp',
  initialState,
  reducers: {
    setOnboardingState: (state, { payload }: PayloadAction<TGDPState['onboardingState']>) => {
      // eslint-disable-next-line no-param-reassign
      state.onboardingState = payload;
    },
  },
});

export const { setOnboardingState } = slice.actions;

export default slice.reducer;

export const selectOnboardingState = (state: TRootState) => state.gdp.onboardingState;
